import { render } from "./Chinese.vue?vue&type=template&id=20066f88&ts=true"
import script from "./Chinese.vue?vue&type=script&lang=ts"
export * from "./Chinese.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__